const sprintFactor = 2.43;
export  default sprintFactor;
